import { JobRecord } from './jobWorkspaceModel';

export const jobTabs = ['Current', 'Completed', 'Lost / Withdrawn', 'All'] as const;
export const proposalTabs = ['Current Proposals', 'Approved', 'History', 'All'] as const;
export type JobFilter = typeof jobTabs[number];
export type ProposalFilter = typeof proposalTabs[number];
const status = (record: JobRecord) => String(record.status || '').trim().toUpperCase().replace(/[ -]+/g, '_');
export const jobCategory = (record: JobRecord): JobFilter => {
  if (['COMPLETED', 'COMPLETE'].includes(status(record))) return 'Completed';
  if (['LOST', 'REJECTED', 'WITHDRAWN', 'CANCELED', 'CANCELLED', 'ARCHIVED'].includes(status(record))) return 'Lost / Withdrawn';
  return 'Current';
};
export const proposalCategory = (record: JobRecord): ProposalFilter => {
  if (['APPROVED', 'ACCEPTED', 'PRE_PRODUCTION', 'WON'].includes(status(record))) return 'Approved';
  if (['REJECTED', 'SUPERSEDED', 'WITHDRAWN', 'ARCHIVED', 'LOST', 'CANCELLED', 'CANCELED', 'COMPLETED', 'COMPLETE'].includes(status(record))) return 'History';
  return 'Current Proposals';
};
export const quoteJobId = (quote: JobRecord): string | undefined => quote.linkedCrmItemId || quote.lead_id || quote.leadId;
const time = (value: any) => { const result = Date.parse(value || ''); return Number.isFinite(result) ? result : 0; };
export const recentTime = (record: JobRecord) => time(record.updated_at || record.updatedAt || record.created_at || record.createdAt);
export const filterJobs = (records: JobRecord[], filter: JobFilter, search: string, now = Date.now()) => {
  const term = search.trim().toLowerCase();
  return records.filter(record => (filter === 'All' || jobCategory(record) === filter) &&
    [record.project_ref, record.event_type, record.title, record.name, record.id].some(value => String(value || '').toLowerCase().includes(term)))
    .sort((a, b) => {
      if (filter === 'Current') {
        const today = new Date(now); today.setHours(0, 0, 0, 0);
        const upcoming = (record: JobRecord) => { const date = time(record.event_date || record.eventDate); return date >= today.getTime() ? date : Infinity; };
        const first = upcoming(a), second = upcoming(b);
        if (first !== second) return first - second;
      }
      return recentTime(b) - recentTime(a) || String(a.id).localeCompare(String(b.id));
    });
};
export const filterProposals = (records: JobRecord[], filter: ProposalFilter, jobId: string | null) =>
  records.filter(record => !record.is_base_template && (!jobId || quoteJobId(record) === jobId) && (filter === 'All' || proposalCategory(record) === filter))
    .sort((a, b) => recentTime(b) - recentTime(a) || String(a.id).localeCompare(String(b.id)));

export const groupProposals = (records: JobRecord[]) => {
  const groups = new Map<string, JobRecord[]>();
  records.forEach(record => { const key = quoteJobId(record) || ''; groups.set(key, [...(groups.get(key) || []), record]); });
  return Array.from(groups, ([jobId, quotes]) => ({ jobId, quotes }));
};
